import './main_menu';
import './common.sass';
import './auth.sass';
import Api from './api';
import './scroll-tracker.js';

if ('serviceWorker' in navigator) {
    try {
        navigator.serviceWorker
            .register('/static/js/pwa.js', {scope: '/'})
            .then(() => { 
                //console.log('Service Worker Registered'); 
            });
    }catch(e) {
        console.log(e);
    }
}

window.addEventListener('beforeinstallprompt', (e) => {
    //// Prevent Chrome 67 and earlier from automatically showing the prompt
    //e.preventDefault();
    //console.warn("DESKTOP PWA: beforeinstallprompt");
});


export default class LikeBlock {
    constructor(likeBlock) {
        let button = likeBlock.querySelector('.cmd-like');
        button.onclick = async e => {
            e.preventDefault();
            if (likeBlock.classList.contains('liked')) return;
            let targetId = likeBlock.dataset.id;
            if (!targetId) {
                console.error("Like target is not defined", likeBlock);
                return;
            }
            let countLabel = likeBlock.querySelector('.like-count');
            console.log(likeBlock, countLabel);
            let count = +countLabel.dataset.value;
            count = count + 1;
            countLabel.textContent = count < 1000 ? "" + count : Math.round(count/100)/10 + "k";
            countLabel.style.display = 'inline';

            likeBlock.classList.add('liked');
            await Api.like(targetId);
        };
    }
}

Object.defineProperty(Array.prototype, 'chunk', {
    value: function (chunkSize) {
        var result = [];
        for (var i = 0; i < this.length; i += chunkSize)
            result.push(this.slice(i, i + chunkSize));
        return result;
    }
});


window.perf_test = (n) => {
    for (var i = 0; i < n; ++i) {
        Api.saveUserSkill("05YrEBRnq8E56W4akqBA8beL", i % 2 == 0, i % 10);
    }
};

let likeBlocks = document.getElementsByClassName('like-this-block');
for (let i = 0; i < likeBlocks.length; ++i) {
    new LikeBlock(likeBlocks[i]);
}

var inputs = document.querySelectorAll('[data-validation-regex], [data-validation-required]');
for (var i in inputs) {
    if (!inputs.hasOwnProperty(i)) {
        continue;
    }
    var input = inputs[i];

    input.onblur = function () {
        var errorMessages = validateInput(this);

        var errorContainer = this.parentNode;
        while (!errorContainer.classList.contains('form-group')) {
            errorContainer = errorContainer.parentNode;
        }

        var div = errorContainer.querySelector('div.invalid-feedback');
        if (!div) {
            div = document.createElement('div');
            div.classList.add('invalid-feedback');
            errorContainer.appendChild(div);
        }
        div.innerHTML = errorMessages.join('<br />');
    }
}

var formList = document.querySelectorAll('form');
for (var i in formList) {
    if (!formList.hasOwnProperty(i)) {
        continue;
    }
    var form = formList[i];

    if (form.onsubmit) {
        var tmp = form.onsubmit;
    } else {
        var tmp = function () {
            return true;
        };
    }

    form.onsubmit = function (a, b, c) {
        var result = true;
        var inputs = form.querySelectorAll('input');
        for (var i in inputs) {
            if (!inputs.hasOwnProperty(i)) {
                continue;
            }
            var input = inputs[i];

            var errorMessages = validateInput(input);
            if (errorMessages.length > 0) {
                result = false;
            }
        }

        return tmp(a, b, c) && result;
    }

    
}

let validateInput = input => {
    var errorMessages = [];
    if (input.hasAttribute('data-validation-regex')) {
        var regex = new RegExp(input.getAttribute('data-validation-regex').toString());
        if (!regex.test(input.value)) {
            input.classList.add('is-invalid');
            if (input.hasAttribute('data-validation-error')) {
                errorMessages.push(input.getAttribute('data-validation-error'));
            } else {
                errorMessages.push('Invalid format');
            }
        }

        console.log(input.value, regex);
    }

    if (input.hasAttribute('data-validation-required')) {
        if (input.value == "") {
            input.classList.add('is-invalid');
            errorMessages.push('Field required');
        }
    }

    if (input.hasAttribute('data-validation-equal-to')) {
        var selector = input.getAttribute('data-validation-equal-to');
        var otherInput = document.querySelector(selector);
        if (input.value != otherInput.value) {
            if (input.hasAttribute('data-validation-error')) {
                errorMessages.push(input.getAttribute('data-validation-equal-to-error'));
            } else {
                errorMessages.push('Values must be equal');
            }
        }
    }

    if (errorMessages.length == 0) {
        input.classList.remove('is-invalid');
    } else {
        input.classList.add('is-invalid');
    }

    return errorMessages;
}

function logEvent(data) {
    try {
        const blob = new Blob([JSON.stringify(data)], { type: 'application/json; charset=UTF-8' });
        navigator.sendBeacon('/api/event', blob);
    }catch(e){ 
        log.error(e);
    }
}

document.addEventListener('visibilitychange', function() {
    //logEvent({ targetId: "", targetName: "page", type: "visibility", name: document.visibilityState, data: location.href });
});

logEvent({ targetId: "", targetName: "page", type: "open", name: "", data: location.href });


{
    let deferredPrompt = null;
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        //console.log("On beforeinstallprompt!");        
        deferredPrompt = e;
        window.canBeInstalled = true;
    });

    setInterval(() => {
      const installApp = document.getElementById('installApp');
      if (!installApp) return;
      if (installApp.onclick != null) return;
      installApp.onclick = async () => {
          if (deferredPrompt !== null) {
              deferredPrompt.prompt();
              const { outcome } = await deferredPrompt.userChoice;
              console.log(outcome);
              if (outcome === 'accepted') {
                  deferredPrompt = null;
              }
          }
      };
      console.log("Installed handler on installApp button");
    }, 100);
}